import { usePredictionMarketEventsFindTrending } from '@/lib/endpoints';
import { CollapsibleSection } from './CollapsibleSection';
import { TrendingContent } from './TrendingContent';

export interface TrendingSectionProps {
  /** Event whose related ("People Are Also Trading") markets to list. */
  eventId: string;
  /** Section title (from the admin section config). */
  title: string;
  /** Initial expanded state (admin `defaultOpen`, §7.1). */
  defaultOpen?: boolean;
}

/**
 * "People Are Also Trading" market-page section (ARC-161).
 *
 * Owns the trending fetch and the render/hide decision: per the PRD the tab
 * renders <b>only</b> when there is at least one eligible market. While loading,
 * on error, or when the API returns an empty list (feature off, provider
 * empty/timeout, or zero eligible after filtering), the whole section is
 * absent — no header, no chevron, no empty state.
 */
export function TrendingSection({ eventId, title, defaultOpen }: TrendingSectionProps) {
  const { data, isLoading, isError } = usePredictionMarketEventsFindTrending(eventId);
  const markets = data?.markets ?? [];

  if (isLoading || isError || markets.length === 0) return null;

  return (
    <CollapsibleSection title={title} defaultOpen={defaultOpen}>
      <TrendingContent markets={markets} />
    </CollapsibleSection>
  );
}
